export const calculateTextWidthCavnas = ({ text = '', isBold = false, fontFamily = 'Inter', fontSize = '12' }) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d') as CanvasRenderingContext2D;
  context.font = `${isBold ? 'bold ' : ''} ${fontSize}px ${fontFamily}`;
  return context.measureText(text).width;
};

export enum QueryTypeEnum {
  CACHED_RESULT = 'CACHED_RESULT',
  OBJECT_ASYNC = 'OBJECT_ASYNC',
  SQL_QUERY = 'SQL_QUERY',
}

export const DEFAULT_COMPOSED_CHART_Y_WIDTH_VERTICAL = 45;
export const DEFAULT_COMPOSED_CHART_X_HEIGHT = 30;
export const DEFAULT_COMPOSED_CHART_Y_WIDTH_HORIZONTAL = 50;

export const isSelectedDot = (selected: { name: string }[], dotProps) =>
  (!!selected?.length &&
    selected[0].name === (Array.isArray(dotProps.payload.date) ? dotProps.payload.date.join(', ') : dotProps.payload.date)) ||
  (!!selected?.length && selected[0].name === dotProps.payload.originalValue);
